import { useNavigate } from "react-router-dom";
import AuthCard from "@/components/auth/AuthCard";
import AuthButton from "@/components/auth/AuthButton";

// PaymentCancelled — Stripe redirects here if the user cancels checkout.
export default function PaymentCancelled() {
  const navigate = useNavigate();
  return (
    <AuthCard
      title="Payment cancelled"
      subtitle="No charge was made. You can try again anytime."
    >
      <p className="text-xs text-center mb-4" style={{ color: "#9a9a9a" }} data-testid="payment-cancelled-message">
        Your card was not charged.
      </p>
      <AuthButton onClick={() => navigate("/auth/purchase-plan", { replace: true })} testid="payment-cancelled-back">
        Back to plans
      </AuthButton>
    </AuthCard>
  );
}
